module.exports = __webpack_public_path__ + "img/slika7.f40e8864.jpg";